import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {RefreshTokenService} from './refresh-token.service';
import {AuthenticationService} from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(
    private http: HttpClient,
    private refreshTokenService: RefreshTokenService,
  ) {
  }

  private loginurl = '';

  initRefreshJwtToken() {
    // Only the main application window may drive the token refresh cycle.
    // Popups (scheduler, studio, reports, collage, configuration, notes, ...) are
    // opened via window.open() and bootstrap their own Angular app instance, so they
    // would each independently call refresh-token. With refresh-token rotation on the
    // backend, the first window to refresh invalidates the token the others hold,
    // causing spurious "isSuccess: false" responses and unexpected logouts.
    // Popups carry a non-null window.opener; the main window does not.
    if (!this.isMainWindow())
      return;

    const token = localStorage.getItem('TDOauthToken');
    if (token)
      this.refreshTokenService.refreshJwtToken();
    setInterval(() => {
      this.refreshTokenService.refreshJwtToken();
    }, 14 * 60 * 1000);
  }

  private isMainWindow(): boolean {
    try {
      return !window.opener;
    } catch {
      // Cross-origin access to window.opener can throw; treat as a popup to stay safe.
      return false;
    }
  }
}
